import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PanelContainer } from '../../common/panel/PanelContainer'
import { SelectCurrencyUnit } from '../../common/selectCurrencyUnit'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import { changeAllowSetDefaultUnit } from '../../common/selectCurrencyUnit/slice'
import { Layout } from '../Layout'
import { CompanyInfo } from '../common/header/companyInfo'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import { Filter } from '../common/header/filterBar'
import useGetIcb from './../../common/category/useGetIcb'
import useGetVsic from './../../common/category/useGetVsic'
import { PanelItem } from './PanelItem'
import { PANEL_DATA } from './constant'
import { Highlight } from './highlight'
import './lang/i18n'
import { resetStore, selectLoading } from './store/slice'
import { getCompanyHighlight, getCompanyInfoDetail } from './store/thunk'

const CompanyProfile = () => {
  const screen = SCREEN.COMPANY_PROFILE
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const { loading: loadingIcb } = useGetIcb()
  const { loading: loadingVsic } = useGetVsic()
  const isLoadingDetail = useSelector(selectLoading('companyInfoDetail'))
  const isLoadingHighlight = useSelector(selectLoading('companyHighlight'))
  const { organizationId, fiscalYearEnd } = useSelector(selectCompanyInfo)

  const isLoading =
    isLoadingDetail || isLoadingHighlight || loadingIcb || loadingVsic

  useEffect(() => {
    if (!organizationId) return
    dispatch(
      getCompanyHighlight({
        OrganizationId: organizationId,
        fiscalYearEnd: new Date(fiscalYearEnd).getFullYear(),
      }),
    )
    dispatch(getCompanyInfoDetail({ OrganizationId: organizationId }))
  }, [locale, organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    if (!isLoading) {
      dispatch(changeAllowSetDefaultUnit({ screen, value: false }))
    }
  }, [isLoading])

  const renderBottomComponent = () => {
    return (
      <>
        <Highlight />
        <PanelContainer>
          {PANEL_DATA.map((item) => (
            <PanelItem key={item.id} item={item} />
          ))}
        </PanelContainer>
      </>
    )
  }

  const renderStickyComponent = () => (
    <Filter
      renderRight={() => <SelectCurrencyUnit screen={SCREEN.COMPANY_PROFILE} />}
    />
  )

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={renderStickyComponent}
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={isLoading}
      isShowFooter={false}
    />
  )
}

export default CompanyProfile
